import { render } from "./InterstitialFour.vue?vue&type=template&id=9f90558a&scoped=true"
import script from "./InterstitialFour.vue?vue&type=script&lang=js"
export * from "./InterstitialFour.vue?vue&type=script&lang=js"

import "./InterstitialFour.vue?vue&type=style&index=0&id=9f90558a&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f90558a"]])

export default __exports__